/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSubscribers
 */
export interface UserSubscribers {
    /**
     * 
     * @type {string}
     * @memberof UserSubscribers
     */
    userId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSubscribers
     */
    subscriberIds?: Array<string>;
}

/**
 * Check if a given object implements the UserSubscribers interface.
 */
export function instanceOfUserSubscribers(value: object): value is UserSubscribers {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;

    return isInstance;
}

export function UserSubscribersFromJSON(json: any): UserSubscribers {
    return UserSubscribersFromJSONTyped(json, false);
}

export function UserSubscribersFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSubscribers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'subscriberIds': !exists(json, 'subscriber_ids') ? undefined : json['subscriber_ids'],
    };
}

export function UserSubscribersToJSON(value?: UserSubscribers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'subscriber_ids': value.subscriberIds,
    };
}

